module.exports = "<div [class.is-collapsed]=\"collapsed\" [class.active]=\"!collapsed\" [ngClass]=\"customClass\">\n  <ng-content></ng-content>\n</div>\n"